export default "__VITE_ASSET__BiFvKh8H__"